var map = {
	"./logout.png": "42c4",
	"./menu_ic_10_customerservice.png": "4294",
	"./menu_ic_11_tg.png": "d309",
	"./menu_ic_12_fb.png": "5574",
	"./menu_ic_1_home.png": "d9ef",
	"./menu_ic_2_member.png": "dbbf",
	"./menu_ic_3_share.png": "7c5c",
	"./menu_ic_4_recharge.png": "00b8",
	"./menu_ic_5_myaccount.png": "fbc0",
	"./menu_ic_6_record.png": "804f",
	"./menu_ic_7_myactivity.png": "495d",
	"./menu_ic_8_messages.png": "0418",
	"./menu_ic_9_vipbenefits.png": "628a",
	"./menu_ic_billboard.png": "c346",
	"./menu_ic_partner.png": "3a59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "03e2";